export const FETCH_GATE_ENTRY_SCANNED_LIST_REQUEST = 'FETCH_GATE_ENTRY_SCANNED_LIST_REQUEST';
export const FETCH_GATE_ENTRY_SCANNED_LIST_SUCCESS = 'FETCH_GATE_ENTRY_SCANNED_LIST_SUCCESS';
export const FETCH_GATE_ENTRY_SCANNED_LIST_FAILURE = 'FETCH_GATE_ENTRY_SCANNED_LIST_FAILURE';

export const CREATE_USER_FORM_GATE_ENTRY = 'CREATE_USER_FORM_GATE_ENTRY';

export const FETCH_GATE_ENTRY_AGAINST_PODC_REQUEST = 'FETCH_GATE_ENTRY_AGAINST_PODC_REQUEST';
export const FETCH_GATE_ENTRY_AGAINST_PODC_SUCCESS = 'FETCH_GATE_ENTRY_AGAINST_PODC_SUCCESS';
export const FETCH_GATE_ENTRY_AGAINST_PODC_FAILURE = 'FETCH_GATE_ENTRY_AGAINST_PODC_FAILURE';